<template>
  <div class="page-wrapper">

  </div>
</template>

<script>
    import {queryOrders} from "../api/order";

    export default {
        name: "Orders",
      data() {
          return {
            orders:[],
          }
      },
      created() {

      },
      mounted() {
      },
      methods: {

      }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Orders.vue